import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider.js';
import { useShowConsumerCampaignSettingsById } from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';

import { RegistrationModal } from '../../../components/Modals/RegistrationModal';

export const RegistrationPage = () => {
  const navigate = useNavigate();
  const { causeId, campaignId } = useCrowdfundingProvider();
  const { data: campaignSettings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });

  if (campaignSettings?.isRegistrationByAdminOnly) {
    navigate('..');
  }

  return <RegistrationModal opened={true} />;
};
